import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Back to the top on every route change.
 *
 * Since 2026-10-22 the page scrolls inside .dashboard-main-body (the bar
 * stays on screen above it), so that box is scrolled as well as the window --
 * the window still scrolls on the sign-in page, which has no shell.
 */
const RouteScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.querySelector('.dashboard-main-body')?.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default RouteScrollToTop;
